import type { TreeNodeType } from '@/shared/lib/tree'
import type { FieldConfig, ValueState } from '../../types'

import { findNodes } from '@/shared/lib/tree'

import { Operators } from '../../constants'
import { isObject, stringToArray } from '../../utils/utils'
import FieldController from '../Controller'

type Options = any[]

export default class TreeSelectController extends FieldController {
	constructor(config: FieldConfig) {
		super(config)
		this.useSelectOptions = config.useSelectOptions
		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.placeholder = config.placeholder
	}

	useSelectOptions: () => Options

	hasValue = (value: any) =>
		Array.isArray(value) ? value.length > 0 : isObject(value)

	getInitialValue = () => ({ operation: Operators.ANY_OF, value: [] })
	formatState = (
		{ value, operation }: ValueState,
		options?: TreeNodeType[]
	) => {
		const _value = stringToArray(value || '')
		const selectedOptions = findNodes(options || [], _value)
		if (_value?.length === selectedOptions.length) {
			return {
				operation: '',
				value: selectedOptions.map((o) => o.name).join(', '),
			}
		}

		return { operation, value }
	}
	formatLabel = (value: any) => {
		if (Array.isArray(value) && value.length > 0)
			return (
				this.locale.getSelectedCountMessage?.(value.length) ||
				`Selected (${value.length})`
			)

		return this.locale?.getSelectValuePlaceholder?.() || 'Select'
	}
}
